import { Box } from '@mui/material';
import { TagItem } from 'src/features/sites/components/tag-item';
type Props = {
  formttedTags: any;
  liveDataComplete: any;
  isMobile: boolean;
};

export const LiveTagsList = ({ formttedTags, isMobile, liveDataComplete }: Props) => {
  console.log('test');
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
        }}
      >
        {formttedTags
          ?.filter((_: any, index: number) => index % 2 === 0)
          .map((tag: any) => (
            <TagItem
              testId={`tag-item-${tag.id}`}
              key={tag.id}
              tag={tag}
              isMobile={isMobile}
              liveDataComplete={liveDataComplete}
              isLiveDataWidget={true}
              isLiftStationMobile={isMobile}
              isLiftStation={true}
            />
          ))}
      </Box>

      <Box
        sx={{
          width: '1px',
          backgroundColor: 'grey',
          mx: 2,
          alignSelf: 'stretch',
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
        }}
      >
        {formttedTags
          ?.filter((_: any, index: number) => index % 2 === 1)
          .map((tag: any) => (
            <TagItem
              testId={`tag-item-${tag.id}`}
              key={tag.id}
              tag={tag}
              isMobile={isMobile}
              liveDataComplete={liveDataComplete}
              isLiveDataWidget={true}
              isLiftStationMobile={isMobile}
              isLiftStation={true}
            />
          ))}
      </Box>
    </Box>
  );
};
